import { render } from "./HauptMenu.vue?vue&type=template&id=1d42fe4f"
import script from "./HauptMenu.vue?vue&type=script&lang=js"
export * from "./HauptMenu.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__